// The table colours this account has unlocked with a video. The server keeps
// them (GET /table-themes, backend/table_unlocks.py); lib/tableThemes.js holds
// the page's copy. AuthContext asks for them whenever the player changes.
import { api } from "./api";
import { showRewardedVideo } from "./ads";
import { setTableUnlockRefresh, setTableUnlocks } from "./tableThemes";

export async function refreshTableUnlocks() {
  const { data } = await api.get("/table-themes");
  setTableUnlocks(data?.unlocks);
}

// When an unlock runs out, the server says whether a game in progress renewed it.
setTableUnlockRefresh(refreshTableUnlocks);

/**
 * The whole unlock of colour `id`: the video, then the server. Resolves to
 * "unlocked", or what kept it from happening: "dismissed" (video closed before
 * the end), "failed" (no video came), "unavailable" (no video on this page:
 * the website), "error" (the server could not save it).
 */
export async function unlockTableThemeWithVideo(id) {
  // While the video is on screen, the server knows it (POST /ad-break): the other
  // players see « Pub couleur » instead of « Déco », the host may replace this
  // player with a bot, and a waiting room keeps their seat.
  let started = null;
  const result = await showRewardedVideo({
    onStart: () => {
      started = api.post("/ad-break", { active: true }).catch(() => {});
    },
  });
  // The end goes after the start, or a late start would outlive the video.
  if (started) started.then(() => endAdBreak());
  if (result !== "rewarded") return result;
  // The video was watched: try hard to save it.
  for (let attempt = 0; ; attempt++) {
    try {
      const { data } = await api.post(`/table-themes/${encodeURIComponent(id)}/unlock`);
      setTableUnlocks(data?.unlocks);
      return "unlocked";
    } catch (e) {
      const status = e?.response?.status;
      if (attempt >= 2 || (status && status < 500)) return "error";
      await new Promise((r) => setTimeout(r, 1000 * (attempt + 1)));
    }
  }
}

// The page may still be offline for a moment after the video: one more try.
// Without an answer, the server ends the break by itself after 2 minutes.
function endAdBreak(retry = true) {
  api.post("/ad-break", { active: false }).catch(() => {
    if (retry) setTimeout(() => endAdBreak(false), 3000);
  });
}
